export const servicesData = [
  {
    id: 1,
    name: 'Computer Install',
    homePrice: 148,
    businessPrice: 175
  },
  {
    id: 2,
    name: 'Data Backup & Restore',
    homePrice: 148,
    businessPrice: 175
  },
  {
    id: 3,
    name: 'Data Recovery',
    homePrice: 148,
    businessPrice: 175
  },
  {
    id: 4,
    name: 'Email Setup',
    homePrice: 148,
    businessPrice: 175
  },
  {
    id: 5,
    name: 'Hardware Install',
    homePrice: 148,
    businessPrice: 175
  }
];